function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-2{fill:#f90;}.cls-1{fill:none;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("title", null, "Amazon-EC2_AMI_dark-bg");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Working"
}, React.createElement("path", {
  className: "cls-2",
  d: "M42.05,48.5H8A6.45,6.45,0,0,1,1.5,42.05V8A6.45,6.45,0,0,1,8,1.5h34.1A6.45,6.45,0,0,1,48.5,8v34.1A6.45,6.45,0,0,1,42.05,48.5ZM8,3.5A4.46,4.46,0,0,0,3.5,8v34.1A4.46,4.46,0,0,0,8,46.5h34.1a4.46,4.46,0,0,0,4.45-4.45V8A4.46,4.46,0,0,0,42.05,3.5Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M41.88,22.25H8.13a1,1,0,0,1-1-1V10a1,1,0,0,1,1-1H41.88a1,1,0,0,1,1,1V21.25A1,1,0,0,1,41.88,22.25Zm-32.75-2H40.88V11H9.13Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M41.88,41.94H8.13a1,1,0,0,1-1-1V26.88a1,1,0,0,1,1-1H41.88a1,1,0,0,1,1,1V40.94A1,1,0,0,1,41.88,41.94Zm-32.75-2H40.88V27.88H9.13Z"
}), React.createElement("rect", {
  className: "cls-2",
  x: 18.38,
  y: 10,
  width: 2,
  height: 11.25
}), React.createElement("rect", {
  className: "cls-2",
  x: 29.63,
  y: 10,
  width: 2,
  height: 11.25
}), React.createElement("rect", {
  className: "cls-2",
  x: 18.38,
  y: 26.88,
  width: 2,
  height: 14.06
}), React.createElement("rect", {
  className: "cls-2",
  x: 29.63,
  y: 26.88,
  width: 2,
  height: 14.06
}), React.createElement("rect", {
  className: "cls-1",
  width: 50,
  height: 50
}));

var SvgAwsAmi = function SvgAwsAmi(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    className: "svgCloudServices",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAwsAmi, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AWS-AMI.15035792.svg";
export { ForwardRef as ReactComponent };